// src/components/Dashboard/DashboardSidebar.jsx
import React from "react";
import {
  X as CloseIcon,
  Home,
  User,
  ShoppingCart,
  FileText,
  FileImage,
} from "lucide-react";
import MenuButton from "./MenuButton";
import { useNavigate } from "react-router-dom";

const DashboardSidebar = ({
  isMobile,
  isSidebarOpen,
  currentView,
  setCurrentView,
  toggleSidebar,
}) => {
  const navigate = useNavigate();

  return (
    <>
      {isMobile && isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-20"
          onClick={toggleSidebar}
        />
      )}
      <aside
        className={`fixed md:static bg-white shadow-lg w-64 h-full z-30 transform transition-transform duration-300 ease-in-out ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        } md:translate-x-0`}
      >
        <div className="flex items-center justify-between p-4 border-b">
          <img
            src="https://alpesgas.com.br/wp-content/uploads/2023/01/logo-vermelha-horizontal.png"
            alt="Alpes Gás Logo"
            className="h-6 md:h-8 w-auto"
          />
          {isMobile && (
            <button
              onClick={toggleSidebar}
              className="p-2 rounded-lg hover:bg-gray-100"
            >
              <CloseIcon className="w-5 h-5 text-gray-600" />
            </button>
          )}
        </div>
        <nav className="p-4">
          <ul className="space-y-2">
            <li>
              <MenuButton
                icon={Home}
                text="Início"
                isActive={currentView === "home"}
                onClick={() => {
                  setCurrentView("home");
                  if (isMobile) toggleSidebar();
                }}
              />
            </li>
            <li>
              <MenuButton
                icon={User}
                text="Clientes"
                isActive={currentView === "customers"}
                onClick={() => {
                  setCurrentView("customers");
                  if (isMobile) toggleSidebar();
                }}
              />
            </li>
            <li>
              <MenuButton
                icon={ShoppingCart}
                text="Pedidos"
                isActive={currentView === "orders"}
                onClick={() => {
                  setCurrentView("orders");
                  if (isMobile) toggleSidebar();
                }}
              />
            </li>
            <li>
              <MenuButton
                icon={FileText}
                text="Notas Fiscais"
                isActive={currentView === "invoices"}
                onClick={() => {
                  setCurrentView("invoices");
                  if (isMobile) toggleSidebar();
                }}
              />
            </li>
            <li>
              <MenuButton
                icon={FileImage}
                text="Condição Comercial"
                isActive={currentView === "CondicaoComercial"}
                onClick={() => {
                  setCurrentView("CondicaoComercial");
                  if (isMobile) toggleSidebar();
                }}
              />
            </li>
          </ul>
        </nav>
        <div className="absolute bottom-0 left-0 w-full p-4 text-center text-xs text-gray-400">
          Versão 0.1.0
        </div>
      </aside>
    </>
  );
};

export default DashboardSidebar;
